import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ user, loading, children }) => {
    if (loading) {
        return <div>Loading...</div>; // Prevent redirect until auth state is confirmed
    }

    return user ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;